import { BusinessUnit } from "./BusinessUnit";

export class MarketingCampaign {
  id: string;
  businessUnit: BusinessUnit;
  name: string;
  code: number;
  optionalField1: string | null;
  optionalField2: string | null;
  optionalField3: string | null;
  optionalField4: string | null;

  constructor(campaign?: Partial<MarketingCampaign>) {
    this.id = campaign?.id || "";
    this.businessUnit = campaign?.businessUnit || new BusinessUnit();
    this.name = campaign?.name || "";
    this.code = campaign?.code || 0;
    this.optionalField1 = campaign?.optionalField1 || null;
    this.optionalField2 = campaign?.optionalField2 || null;
    this.optionalField3 = campaign?.optionalField3 || null;
    this.optionalField4 = campaign?.optionalField4 || null;
  }
}
